import { PRODUCT_META } from '@gb-ticket/shared-types';

export const FLEET_ROOT = PRODUCT_META.fleet.pathPrefix;
export const FLEET_VEHICLES_PATH = `${FLEET_ROOT}/fahrzeuge`;
export const FLEET_VEHICLE_NEW_PATH = `${FLEET_VEHICLES_PATH}/neu`;
export const FLEET_DRIVERS_PATH = `${FLEET_ROOT}/fahrer`;
export const FLEET_BOOK_PATH = `${FLEET_ROOT}/buchen`;
export const FLEET_ODOMETER_PATH = `${FLEET_ROOT}/kilometer`;
export const FLEET_REPORT_PATH = `${FLEET_ROOT}/melden`;
export const FLEET_POLICY_PATH = `${FLEET_ROOT}/verwaltung`;
export const FLEET_TASKS_PATH = `${FLEET_ROOT}/aufgaben`;
export const FLEET_REPORTS_PATH = `${FLEET_ROOT}/meldungen`;
export const FLEET_OPERATIONS_PATH = `${FLEET_ROOT}/betrieb`;
export const FLEET_OPERATIONS_MAP_PATH = `${FLEET_OPERATIONS_PATH}/karte`;
export const FLEET_OPERATIONS_CHARGE_PATH = `${FLEET_OPERATIONS_PATH}/laden`;
export const FLEET_ENERGY_PATH = `${FLEET_ROOT}/e-management`;
export const FLEET_OPERATIONS_FUEL_PATH = `${FLEET_OPERATIONS_PATH}/tankkarten`;
export const FLEET_OPERATIONS_COSTS_PATH = `${FLEET_OPERATIONS_PATH}/kosten`;
export const FLEET_TRIPS_PATH = `${FLEET_ROOT}/fahrten`;

export function fleetVehiclePath(id: string): string {
  return `${FLEET_VEHICLES_PATH}/${id}`;
}

export function fleetDriverPath(userId: string): string {
  return `${FLEET_DRIVERS_PATH}/${userId}`;
}

export function fleetDamagePath(id: string): string {
  return `${FLEET_REPORT_PATH}?meldung=${id}`;
}
